const ApplyRouter = {
  path: '/entry-page',
  name: 'Apply',
  redirect: '/entry-page/home',
  component: () => import('@/views/apply/index'),
  children: [
    {
      path: 'home',
      name: 'ApplyHome',
      component: () => import('@/views/apply/home'),
      meta: { title: '报名页' }
    },
    {
      path: 'project-list',
      name: 'ApplyProjectList',
      component: () => import('@/views/apply/components/project-list'),
      meta: { title: '组别列表' }
    },
    {
      path: 'entry-info',
      name: 'ApplyEntryInfo',
      component: () => import('@/views/apply/components/entry-info'),
      meta: { title: '队伍报名单' }
    },
    {
      path: 'entry-info-player',
      name: 'ApplyEntryInfoPlayer',
      component: () => import('@/views/apply/components/entry-info-player'),
      meta: { title: '个人参赛表' }
    },
    {
      path: 'entry-info2',
      name: 'ApplyEntryInfo2',
      component: () => import('@/views/apply/components/entry-info2'),
      meta: { title: '队伍报名单' }
    },
    {
      path: 'entry-info-team',
      name: 'ApplyEntryInfoTeam',
      component: () => import('@/views/apply/components/entry-info-team'),
      meta: { title: '球队报名' }
    },
    {
      path: 'agreement-list',
      name: 'ApplyAgreementList',
      component: () => import('@/views/apply/components/agreement-list'),
      meta: { title: '协议列表' }
    },
    {
      path: 'agreement-confirm',
      name: 'ApplyAgreementConfirm',
      component: () => import('@/views/apply/components/agreement-confirm'),
      meta: { title: '协议确认' }
    },
    {
      path: 'player-quiz-list',
      name: 'ApplyPlayerQuizList',
      component: () => import('@/views/apply/components/player-quiz-list'),
      meta: { title: '问卷/调研' }
    },
    {
      path: 'entry-info-team-detail',
      name: 'ApplyEntryInfoTeamDetail',
      component: () => import('@/views/apply/components/entry-info-team-detail'),
      meta: { title: '球队详情' }
    },
    {
      path: 'entry-info-person',
      name: 'ApplyEntryInfoPerson',
      component: () => import('@/views/apply/components/entry-info-person'),
      meta: { title: '参赛信息-个人' }
    },
    {
      path: 'entry-info-more',
      name: 'ApplyEntryInfoMore',
      component: () => import('@/views/apply/components/entry-info-more'),
      meta: { title: '参赛信息-多人' }
    },
    {
      path: 'entry-list',
      name: 'ApplyEntryList',
      component: () => import('@/views/apply/components/entry-list'),
      meta: { title: '我的参赛' }
    },
    {
      path: 'entry-list-by-group',
      name: 'ApplyEntryListByGroup',
      component: () => import('@/views/apply/components/entry-list-by-group'),
      meta: { title: '报名列表' }
    },
    {
      path: 'entry-certificate/:matchId',
      name: 'ApplyEntryCertificate',
      component: () => import('@/views/apply/components/entry-certificate'),
      meta: { title: '电子参赛证' }
    },
    {
      path: 'wx-invite',
      name: 'ApplyEntryInvite',
      component: () => import('@/views/apply/components/wx-invite'),
      meta: { title: '参赛邀请' }
    },
    {
      path: 'wx-invite-landing',
      name: 'ApplyEntryInviteLanding',
      component: () => import('@/views/apply/components/wx-invite-landing'),
      meta: { title: '邀请好友入队' }
    },
    {
      path: 'payment',
      name: 'ApplyEntryPayment',
      component: () => import('@/views/apply/components/payment'),
      meta: { title: '支付信息' }
    },
    {
      path: 'update-player',
      name: 'ApplyUpdatePlayer',
      component: () => import('@/views/apply/components/update-player'),
      meta: { title: '手机绑定' }
    },
    {
      path: 'correlate-mobile',
      name: 'ApplyCorrelateMobile',
      component: () => import('@/views/apply/components/correlate-mobile'),
      meta: { title: '信息编辑' }
    },
    {
      path: 'transfer-captain',
      name: 'ApplyTransferCaptain',
      component: () => import('@/views/apply/components/transfer-captain'),
      meta: { title: '移交领队' }
    },
    {
      path: 'team-operate',
      name: 'ApplyTeamOperate',
      component: () => import('@/views/apply/components/team-operate'),
      meta: { title: '球队报名' }
    },
    {
      path: 'member-list',
      name: 'ApplyMemberList',
      component: () => import('@/views/apply/components/member-list'),
      meta: { title: '名单' }
    },
    {
      path: 'member-select-list',
      name: 'ApplyMemberSelectList',
      component: () => import('@/views/apply/components/member-select-list'),
      meta: { title: '选择' }
    },
    {
      path: 'player-info',
      name: 'ApplyPlayerInfo',
      component: () => import('@/views/apply/components/player-info'),
      meta: { title: '队员报名' }
    },
    {
      path: 'officer-form',
      name: 'ApplyOfficerForm',
      component: () => import('@/views/apply/components/officer-form'),
      meta: { title: '工作人员信息' }
    },
    {
      path: 'entry-list2',
      name: 'ApplyEntryList2',
      component: () => import('@/views/apply/components/entry-list2'),
      meta: { title: '我的参赛' }
    },
    {
      path: 'person-success',
      name: 'ApplyPersonSuccess',
      component: () => import('@/views/apply/components/person-success'),
      meta: { title: '个人报名成功' }
    },
    {
      path: 'person-info',
      name: 'ApplyPersonInfo',
      component: () => import('@/views/apply/components/person-info'),
      meta: { title: '赛事报名资料' }
    },
    {
      path: 'select-team-list',
      name: 'ApplySelectTeamList',
      component: () => import('@/views/apply/components/select-team-list'),
      meta: { title: '选择球队' }
    },
    {
      path: 'registration-order-list',
      name: 'ApplyRegistrationOrderList',
      component: () => import('@/views/apply/components/registration-order-list'),
      meta: { title: '报名订单' }
    },
    {
      path: 'payment2',
      name: 'ApplyPayment2',
      component: () => import('@/views/apply/components/payment2'),
      meta: { title: '支付信息' }
    },
    {
      path: 'payment-success',
      name: 'ApplyPaymentSuccess',
      component: () => import('@/views/apply/components/payment-success'),
      meta: { title: '支付成功' }
    }
  ]
}
export default ApplyRouter
